import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2025ProgramaInformatico() {
  return <CategoryPage category="anexo30Y31Ano2025ProgramaInformatico" pageTitle="Programa Informatico 2025" />;
}

export default Anexo30Y31Ano2025ProgramaInformatico;
